import { Trans, useTranslation } from "react-i18next";
import { Stack, Typography } from "@mui/material";
import { formatInstallationDate } from "@utils/dateFormat";
import { BroadbandInfo } from "@features/confirmation/components/BroadbandInfo";

interface IParams {
    serviceDate: Date;
}

export const ConfirmationPreOrder = (props: IParams) => {
    const { serviceDate } = props;
    const { t } = useTranslation("confirmation");

    return (
        <Stack spacing={2}>
            <Typography color="secondary" fontWeight={400} variant="normal">
                <Trans
                    i18nKey="preOrderInfo"
                    ns="confirmation"
                    values={{ serviceDate: formatInstallationDate(new Date(serviceDate)) }}
                />
            </Typography>
            <Typography color="secondary" variant="normal">
                {t("equipmentTechnician")}
            </Typography>
            <BroadbandInfo />
        </Stack>
    );
};
